import * as React from 'react';
import { Alert, Button, Container, Fade, Paper, Snackbar, Stack, TextField } from '@mui/material';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import Service from '../../../../util/Service';

export default function RedminePanel() {
    const [redmine, setRedmine] = React.useState({
        api: '',
        login: '',
        password: '',
    });
    const [bannerOpen, setBannerOpen] = React.useState(false);
    const [jsonTxt, setJsonTxt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg] = React.useState({
        severity:'success',
        txt:''
    });

    React.useEffect(()=>{
        buscaRedmine();
    },[])

    const buscaRedmine=()=>{
        Service.GET("/api/security/setting/buscaByTipo/redmine").then(r=>{
            console.log( r );
            if(r && r.length> 0){
                setRedmine(r[0].confs);
            }
        })
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };
    function onChangeRedmine(e) {
        setRedmine({
            ...redmine,
            [e.target.name]: e.target.value
        });
    }
    const handleTesteApi = () => {
        console.log(redmine);
        Service.POST("/api/security/integration/redmine/testeAPI", redmine).then(r => {
            const jsonString = JSON.stringify(r, null, 2);
            setJsonTxt(jsonString);
            setBannerOpen(true);
        })
    }
    const handleSettingSave = () => {
        console.log(redmine);
        Service.POST("/api/security/setting/incluirRedmine", redmine).then(r => {
            setOpen(true);
            setMsg({
                severity:'success',
                txt:'Salvo com sucess!'
            })
        })
    }
    const handleRemoverIntegracao=()=>{
        Service.GET("/api/security/setting/removerRedmine").then(r => {
            setRedmine({
                api: '',
                login: '',
                password: '',
            });
            setOpen(true);
            setMsg({
                severity:'success',
                txt:'Integração removida!'
            })
        })
    }
    return (
        <Container maxWidth="sm" sx={{ height: '85vh', alignContent: 'center' }}>
            <Paper sx={{ 
                    p: 2, 
                    // textAlign: 'center', 
                }}
            >
                <form autoComplete="off">

                    <Stack spacing={2}>
                        <div style={{ width: '100%' }}>
                            <Button variant='contained' onClick={handleRemoverIntegracao} color="error">Remover Integração</Button>
                            <div className='pd-float-dir'>
                                <Button variant='contained' onClick={handleSettingSave}>Salvar</Button>
                                <Button variant='contained' onClick={handleTesteApi}>Testa API</Button>
                            </div>
                        </div>
                        <TextField label="Servidor API RedMine" name="api" required size="small" value={redmine?.api || ""}
                            onChange={onChangeRedmine}
                        />
                        <TextField label="Login" name="login" required size="small" value={redmine?.login || ""}
                            onChange={onChangeRedmine} autoComplete='off'
                        />
                        <TextField label="Senha" type="password" size="small"
                            name="password" autoComplete='off'
                            value={redmine?.password || ""}
                            onChange={onChangeRedmine}
                            placeholder="••••••"
                        />
                    </Stack>
                </form>
            </Paper>

            <TrapFocus open disableAutoFocus disableEnforceFocus>
                <Fade appear={false} in={bannerOpen}>
                    <Paper
                        role="dialog"
                        aria-modal="false"
                        aria-label="Cookie banner"
                        square
                        variant="outlined"
                        tabIndex={-1}
                        sx={{
                            position: 'fixed',
                            top: 0,
                            bottom: 0,
                            left: "80%",
                            right: 0,
                            m: 0,
                            p: 2,
                            borderWidth: 0,
                            borderTopWidth: 1,
                            overflow: 'auto'
                        }}
                    >
                        <Stack spacing={2}>
                            <Button variant='contained' onClick={() => setBannerOpen(false)} >Fechar</Button>
                            <pre style={{
                                fontFamily: "cursive",
                                fontStyle: "italic",
                                fontSize: "12px"
                            }}>
                                {jsonTxt}
                            </pre>
                        </Stack>
                    </Paper>
                </Fade>
            </TrapFocus>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={msg.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg.txt}
                </Alert>
            </Snackbar>
        </Container >
    )
}